<template>
  <main>
    <LocationSection />
  </main>
</template>

<script>
import LocationSection from '../components/LocationSection.vue'

export default {
  name: 'LocationPage',
  components: {
    LocationSection
  }
}
</script>
